import GLightbox from 'glightbox';

const videoLightbox = () => {
  const lightbox = GLightbox({
    selector: '.j-video-lightbox',
    autoplayVideos: true,
  })
};

videoLightbox();
